import type { ReactNode } from 'react';

export function TargetingSection({
  action,
  children,
  title,
}: {
  action?: ReactNode | undefined;
  children: ReactNode;
  title: string;
}) {
  return (
    <section className="border-border bg-card grid gap-4 rounded-md border p-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="text-foreground text-sm font-semibold">{title}</h3>
        {action}
      </div>
      {children}
    </section>
  );
}
